import { useChartCtx } from '@weenat/client/dist/core/charts'
import { isNil } from 'lodash-es'
import { useMemo } from 'react'
import { useTheme } from 'styled-components'

const Guidelines = () => {
  const { colors } = useTheme()

  const { width, marginLeft, marginRight, yScale, ticksCount } = useChartCtx()

  const gridStartOnX = marginLeft
  const gridEndOnX = (width ?? 0) - (marginLeft ?? 0) - (marginRight ?? 0)

  const ticks = useMemo(() => {
    if (isNil(yScale)) return []

    return yScale.ticks(ticksCount).map((value) => {
      return yScale(value)
    })
  }, [yScale, ticksCount])

  return (
    <g transform={`translate(${gridStartOnX ?? 0}, 0)`}>
      {ticks.map((yOffset) => (
        <line
          key={yOffset}
          strokeDasharray={'3 8'}
          x1={0}
          x2={gridEndOnX}
          y1={yOffset ?? 0}
          y2={yOffset ?? 0}
          stroke={colors.grayscale[200]}
        />
      ))}
    </g>
  )
}

export default Guidelines
